<!--
  功能：账户授权失效的消息通知
-->
<template>
  <el-popover class="avatarBox" @after-leave="resetTabs"
    placement="bottom" v-model="visible"
    width="300"
    trigger="click">
    <div class="message">
      <el-tabs v-model="activeName" @tab-click="tabClick" class="direction-tabs province-tabs message-tabs">
        <el-tab-pane label="未读消息" name="first">
          <el-collapse @change="handleChange" accordion v-model="messageId" class="mes-collapse"
          v-if="unreadList.length !== 0"
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled">
            <el-collapse-item v-for="(item, index) in unreadList" :key="index" :name="item.id">
              <template slot="title">
                <div class="collapse-title" :class="item.readFlag === 0 ? 'unread' : ''">
                  <span class="collapse-name">授权失效</span>
                  <div class="fr">{{item.createTime}}</div>
                </div>
              </template>
              <div class="message-info">
                <div>{{item.content}}
                  <span class="detail-btn" @click="jumpAccount(item.platformType)">查看详情</span>
                </div>
              </div>
            </el-collapse-item>
            <p class="loadtext" v-if="loading">加载中...</p>
            <p class="loadtext" v-if="noMore"></p>
          </el-collapse>
          <div class="null-box" v-else>
            <img class="" src="@/assets/img/project_manage_null.png" alt="">
            <p>无未读消息</p>
          </div>
          <div v-if="unreadList.length !== 0" class="footer-div"><el-checkbox @change="checkedAll" v-model="checked">全部标记为已读</el-checkbox></div>
        </el-tab-pane>
        <el-tab-pane label="全部消息" name="second">
          <el-collapse @change="handleChange" accordion v-model="messageId" class="mes-collapse"
          v-if="readList.length !== 0"
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled">
            <el-collapse-item v-for="(item, index) in readList" :key="index" :name="item.id">
              <template slot="title">
                <div class="collapse-title" :class="item.readFlag === 0 ? 'unread' : ''">
                  <span class="collapse-name">授权失效</span>
                  <div class="fr">{{item.createTime}}</div>
                </div>
              </template>
              <div class="message-info">
                <div>{{item.content}}
                  <span class="detail-btn" @click="jumpAccount(item.platformType)">查看详情</span>
                </div>
              </div>
            </el-collapse-item>
            <p class="loadtext" v-if="loading">加载中...</p>
            <p class="loadtext" v-if="noMore"></p>
          </el-collapse>
          <div class="null-box" v-else>
            <img class="" src="@/assets/img/project_manage_null.png" alt="">
            <p>无消息</p>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div slot="reference" class="clearfix user">
      <div class="avatar">
        <i class="iconfont icon-avatar"></i>
        <div class="num" v-if="total > 0">{{total}}</div>
      </div>
    </div>
  </el-popover>
</template>

<script>
import { getLocalTime } from '@/components/public'
import { mapGetters } from 'vuex'
export default {
  name: 'messageNotice',
  props: [
    // 'active'
    // 'adviceList'
  ],
  data () {
    return {
      visible: false,
      activeName: 'first',
      unreadList: [],
      total: 0, // 总条数
      messageId: '',
      checked: false,
      readList: [], // 全部消息
      pageSize: 10, // 每页条数
      num: 1,
      loading: false,
      totalPage: ''
    }
  },
  created () {
    this.resetTabs()
  },
  mounted () {
    setInterval(() => {
      this.resetTabs()
    }, 3600000)
  },
  computed: {
    ...mapGetters(['screeningProduct', 'screeningProject']),
    noMore() {
      // 当起始页数大于等于总页数时停止加载
      return this.num >= this.totalPage
    },
    disabled() {
      return this.loading || this.noMore
    }
  },
  methods: {
    // 上拉加载
    load () {
      // 滑到底部时进行加载
      this.loading = true
      setTimeout(() => {
        this.num += 1 // 滚动条到底时，页码自增 1
        this.getMessages() // 调用接口
      }, 500)
    },
    // 获取消息数据
    getMessages () {
      this.$service.post('/api/user/messages/list', {
        projectId: this.screeningProject,
        readFlag: this.activeName === 'first' ? 0 : 2, // 0未读消息列表 1：已读消息列表 2：全部消息
        pageNum: this.num,
        pageSize: this.pageSize
      }).then(res => {
        if (res.code === 200) {
          res.result.pageData.forEach((item, index) => {
            item.createTime = getLocalTime(new Date(item.createTime))
          })
          if (this.activeName === 'first') {
            this.unreadList = [...this.unreadList, ...res.result.pageData] // 合并数组
            this.total = res.result.total
          } else {
            this.readList = [...this.readList, ...res.result.pageData] // 合并数组
          }
          this.totalPage = res.result.totalPage
          this.loading = false
        }
      }).catch(Err => {})
    },
    // 跳转到投放账户管理
    jumpAccount (type) {
      this.visible = false
      if (type === 1) { // 巨量引擎
        this.$router.push({path: '/accountManage/putInAccountManage'})
      } else if (type === 2) { // 巨量千川
        this.$router.push({path: '/qianchuan/account/qcputInAccount'})
      }
    },
    // 重置默认状态
    resetTabs () {
      this.activeName = 'first'
      this.messageId = ''
      this.checked = false
      this.num = 1
      this.unreadList = []
      this.readList = []
      this.getMessages()
    },
    // 切换tab
    tabClick () {
      this.messageId = ''
      this.num = 1
      this.unreadList = []
      this.readList = []
      this.getMessages()
    },
    // 全部标记已读
    checkedAll () {
      if (this.checked) {
        let param = {
          ids: [],
          projectId: this.screeningProject
        }
        this.unreadList.forEach(item => {
          param.ids.push(item.id)
        })
        this.$service.post('/api/user/messages/read', param).then(res => {}).catch(Err => {})
        this.total = 0
        this.resetTabs()
      }
    },
    // 展开消息
    handleChange () {
      if (this.messageId !== '') {
        let item = {}
        if (this.activeName === 'first') {
          item = this.unreadList.filter(i => i.id === this.messageId & i.readFlag === 0)[0]
          console.log(item)
        } else {
          item = this.readList.filter(i => i.id === this.messageId & i.readFlag === 0)[0]
        }
        if (item !== undefined) {
          item.readFlag = 1
          this.$service.post('/api/user/messages/read', {
            ids: [item.id],
            projectId: this.screeningProject
          }).then(res => {
            if (res.code === 200) {
              // console.log(res)
            }
          }).catch(Err => {})
        }
      }
    }
  },
  watch: {
    // active: {
    //   immediate: true,
    //   handler (val) {
    //     console.log(val, 22)
    //     this.activeName = 'first'
    //     this.messageId = ''
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>
@import './../styles/common/public.less';
/deep/ .message-tabs.el-tabs .el-tabs__active-bar{
  width: 56px !important;
}
/deep/ .message-tabs.el-tabs .el-tabs__header .el-tabs__nav-wrap .el-tabs__item{
  height: 38px;
}
/deep/ .message-tabs .el-tabs__header {
  margin: 0 0 5px;
}
/deep/ .message-tabs .el-collapse-item__arrow {
  display: none;
}
/deep/ .message-tabs.el-tabs .el-tabs__header .el-tabs__nav-wrap .el-tabs__item.is-active{
 color: @themeColor;
}
/deep/ .message-tabs .el-collapse-item__header {
  height: 42px;
  line-height: 42px;
}
/deep/ .message-tabs .el-collapse-item__content {
  padding-bottom: 16px;
}
.mes-collapse {
  border-top: none;
  border-bottom: none;
  // max-height: 500px;
  height: 300px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    /*纵向滚动条*/
    width: 7px;
    /*横向滚动条*/
    height: 7px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条滑块颜色*/
    background-color:#c1c1c1;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-track {
    /*滚动条背景色*/
    background-color: transparent;
  }
  .loadtext{
    font-size: 12px;
    line-height: 30px;
  }
  .collapse-title{
    width: 100%;
    text-align: left;
    font-size: 12px;
    &.unread{
      font-weight: bold;
    }
    .collapse-name{
      margin-right: 20px;
    }
  }
  .message-info{
    background-color: #F3F4F4;
    text-align: left;
    padding: 5px;
    font-size: 12px;
    .detail-btn{
      float: right;
      color: @themeColor;
      margin-right: 4px;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
.footer-div{
  text-align: left;
  padding: 5px;
  border-top: 1px solid #EBEEF5;
  /deep/.el-checkbox .el-checkbox__label{
    font-size: 12px;
  }
}
.null-box{
  padding: 10px;
  text-align: center;
  img{
    width: 90px;
  }
  p{
    font-size: 13px;
    padding: 8px 0;
    color: #909399;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/messageNotice.vue